import { render } from "./TrainingUserForm.vue?vue&type=template&id=3bfdc8e6"
import script from "./TrainingUserForm.vue?vue&type=script&lang=js"
export * from "./TrainingUserForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__